export function fmt(n) {
  return Number(n).toLocaleString('en-IN');
}

export function calcRR(entry, target, sl) {
  const reward = Math.abs(target - entry);
  const risk   = Math.abs(entry - sl);
  return risk > 0 ? (reward / risk).toFixed(1) : '-';
}

export function scoreColor(s) {
  if (s >= 80) return '#1D9E75';
  if (s >= 60) return '#BA7517';
  return '#E24B4A';
}

export function sigLabel(sig) {
  if (sig === 'strong-buy') return 'Strong Buy';
  return sig.charAt(0).toUpperCase() + sig.slice(1);
}

export function indicatorClass(value, type) {
  const v = typeof value === 'string' ? value.toLowerCase() : value;
  if (type === 'rsi') return value > 65 ? 'bearish' : value < 40 ? 'bullish' : 'bullish';
  if (type === 'macd') return v.includes('bull') ? 'bullish' : v.includes('bear') ? 'bearish' : 'neutral';
  if (type === 'bb')   return v.includes('break') ? 'bullish' : v.includes('upper band') ? 'bearish' : 'neutral';
  if (type === 'ema')  return v.includes('above') ? 'bullish' : v.includes('below') ? 'bearish' : 'neutral';
  if (type === 'adx')  return value > 25 ? 'bullish' : 'neutral';
  return '';
}

export function rsiLabel(rsi) {
  if (rsi > 65) return 'Overbought — watch for reversal';
  if (rsi < 40) return 'Oversold — bounce candidate';
  return 'Healthy range';
}

export function adxLabel(adx) {
  if (adx > 30) return 'Strong trend';
  if (adx > 20) return 'Moderate trend';
  return 'Weak / choppy';
}
